import { render, staticRenderFns } from "./DeliveryOperations.vue?vue&type=template&id=b727aee6&"
import script from "./DeliveryOperations.vue?vue&type=script&lang=js&"
export * from "./DeliveryOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports